import { INSTRUMENT_ICONS_MAPPING } from '../constants';

export const getPaymentFilterIcon = (filterEnum?: string) => {
	const imgSrc =
		(filterEnum
			? INSTRUMENT_ICONS_MAPPING[
					filterEnum as keyof typeof INSTRUMENT_ICONS_MAPPING
				]
			: INSTRUMENT_ICONS_MAPPING.OTHERS) || INSTRUMENT_ICONS_MAPPING.OTHERS;
	return {
		renderer: <img width={24} height={24} src={imgSrc} alt={filterEnum} />,
		imgSrc,
	};
};
